import axios from "axios";
import {
  GET_KNOWLEDGE_ASSETS,
  INTERACT_CHAT_ENDPOINT,
  INTERACT_CHAT_KNOWLEDGE_ENDPOINT,
  PREVIEW_COBOL,
  PREVIEW_SAS,
  UPLOAD_ENDPOINT,
  DELETE_ASSETS,
  PROJECT_NAME,
  DOWNLOAD_ASSET,
  BI_DOWNLOAD_ASSET,
  EDIT_ASSET_NAME,
  UPDATE_PROJECT_DEFINITION,
  GET_FILE_TYPES,
  PROJECT_DEFINATIONS,
  GET_ALL_ACCOUNT_USERS,
  PREVIEW,
  GENERATE_PDF,
  VALIDATION_ASSET_USER,
  DELETE_QA_RECORDS,
  BI_DELETE_RECORDS,
  PROCESS_QA,
  GET_DB_CONNECTIONS_DETAILS,
  BI_ASSET_USER,
  PROCESS_BI,
  PSEUDO_ASSETS_USER,
  PSEUDO_DELETE_ASSETS,
  PSEUDO_PROCESS,
} from "../constants/endpoints";
import { FAILED_FETCHING_FILES, SUCCESS_MESSAGE } from "../pages/Constants";
import {
  ASSET_SUCCESS,
  ASSET_TYPE,
  DELETE_QA_DATA,
  ERROR_DOWNLOAD_ASSET,
  ERROR_EDIT,
  ERROR_OCCURED,
  ERROR_OPEN_FILE,
  FILE_UPLOADED,
  PREVIEW_FAIL,
  PREVIEW_SUCCESS,
  PROCESS_FAIL,
  PROCESS_SUCCESS,
  TRY_AGAIN,
  UNKNOWN_ERROR,
  UPDATE_FAIL,
} from "../constants/constants";

export const uploadFile = async (params: {
  file?: File;
  operation: string;
  assetName: string;
  type: string;
  projectName: string;
  dbType?: string;
  username?: string;
  host?: string;
  port?: string;
  password?: string;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const {
      file,
      operation,
      assetName,
      type,
      projectName,
      dbType,
      username,
      host,
      port,
      password,
    } = params;

    if (!type) {
      throw new Error(ASSET_TYPE);
    }
    if (!projectName) {
      throw new Error(PROJECT_NAME);
    }

    const formData = new FormData();
    formData.append("project_name", projectName);
    formData.append("asset_type", type);

    if (operation) formData.append("operation", operation);
    if (assetName) formData.append("asset_name", assetName);
    if (file) formData.append("file", file);
    if (dbType) formData.append("db_type", dbType);
    if (username) formData.append("username", username);
    if (host) formData.append("host", host);
    if (port) formData.append("port", port);
    if (password) formData.append("password", password);

    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPLOAD_ENDPOINT}`,

      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || FILE_UPLOADED,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const interactVectorDb = async (
  userInput: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${INTERACT_CHAT_ENDPOINT}`,
      {
        user_input: userInput,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data } = response;
    if (data?.status === SUCCESS_MESSAGE) {
      return {
        success: true,
        data: data?.response,
        message: data?.message,
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const previewKnowledgeAsset = async (
  selected_asset: string
): Promise<{ success: boolean; data?: Blob; message?: string }> => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PREVIEW}${selected_asset}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
        responseType: "blob",
      }
    );

    const { data } = response;

    // return { success: true, data: "data.data" };
    if (response?.status === 200) {
      return {
        success: true,
        data: response?.data,
        message: PREVIEW_SUCCESS,
      };
    }

    return { success: false, message: PREVIEW_FAIL };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const interactKnowledgeAsset = async (body: {
  user_input: string;
  selected_asset: string;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${INTERACT_CHAT_KNOWLEDGE_ENDPOINT}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data } = response;

    // return { success: true, data: "data.data" };
    if (response.data?.status === "success") {
      return {
        success: true,
        data: response?.data,
        message: data.message,
      };
    }

    return { success: false, message: data.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};
export const previewSas = async (fileName: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PREVIEW_SAS}${fileName}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;
    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: true,
        data: data?.message,
      };
    }
  } catch (error) {
    console.error(ERROR_OPEN_FILE, error);
  }
};

export const previewCobol = async (fileName: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PREVIEW_COBOL}${fileName}`,
      {
        // responseType: "blob", // Important to handle binary data
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data, status } = response;
    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: true,
        data: data?.message,
      };
    }
  } catch (error) {
    console.error(ERROR_OPEN_FILE, error);
  }
};

export const getKnowledgeAssetsApi = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_KNOWLEDGE_ASSETS}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;
    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const deleteKnowledgeAssets = async (asset_id: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DELETE_ASSETS}`,
      {
        asset_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const getProjectName = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PROJECT_NAME}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;
    if (data.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const downloadAsset = async (asset_name: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DOWNLOAD_ASSET}${asset_name}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
        responseType: "blob",
      }
    );
    return { success: true, data: response?.data };
  } catch (error) {
    if (error instanceof Error) {
      console.error(ERROR_DOWNLOAD_ASSET, error?.message);
      return { success: false, message: error?.message };
    } else {
      console.error(ERROR_DOWNLOAD_ASSET, error);
      return { success: false, message: UNKNOWN_ERROR };
    }
  }
};
export const biDownloadAsset = async (asset_name: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${BI_DOWNLOAD_ASSET}${asset_name}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
        responseType: "blob",
      }
    );
    return { success: true, data: response?.data };
  } catch (error) {
    if (error instanceof Error) {
      return { success: false, message: error?.message };
    } else {
      return { success: false, message: UNKNOWN_ERROR };
    }
  }
};

export const editAssetName = async (
  project_name: string,
  new_asset_name: string,
  old_asset_name: string
) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${EDIT_ASSET_NAME}?project_name=${project_name}&new_asset_name=${new_asset_name}&old_asset_name=${old_asset_name}`,
      {
        project_name,
        new_asset_name,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data } = response;
    if (data?.status === SUCCESS_MESSAGE) {
      return {
        success: true,
        message: data?.message ?? ASSET_SUCCESS,
      };
    }
    return {
      success: false,
      message: data?.message ?? UPDATE_FAIL,
    };
  } catch (error: any) {
    console.error(ERROR_EDIT, error);
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};
export const updateProjectDefinition = async (
  project_name: string,
  metadata: object,
  file_types: string[],
  user_access: string[]
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPDATE_PROJECT_DEFINITION}`,
      {
        project_name,
        metadata,
        file_types,
        user_access,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const updateProjectApi = async (
  id: string,
  project_name: string,
  metadata: object,
  file_types: string[],
  user_access: string[]
) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPDATE_PROJECT_DEFINITION}/${id}`,
      {
        project_name,
        metadata,
        file_types,
        user_access,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const deleteProjectApi = async (id: string) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPDATE_PROJECT_DEFINITION}/${id}`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const getFileTypes = async (
  project_name: string
): Promise<{ success: boolean; data?: any; message: string }> => {
  const project = project_name?.toString();
  console.log(
    " ?project_name=${project_name}",
    `${process.env.REACT_APP_API_GATEWAY_URL}${GET_FILE_TYPES}?project_name=${project}`
  );
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_FILE_TYPES}`,
      {
        project_name: project,
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;

    if (data) {
      return {
        success: true,
        data: data.file_types,
        message: data?.message ?? "",
      };
    }

    return {
      success: false,
      message: data?.message || FAILED_FETCHING_FILES,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || error.message || ERROR_OCCURED,
    };
  }
};

export const projectDefinationApi = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PROJECT_DEFINATIONS}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;
    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: true,
        data: data?.message,
      };
    }
  } catch (error) {
    console.error(ERROR_OPEN_FILE, error);
  }
};

export const getAllAccountUsersAPi = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ALL_ACCOUNT_USERS}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;

    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: true,
        data: data?.message,
      };
    }
  } catch (error) {
    console.error(ERROR_OPEN_FILE, error);
  }
};

export const processQa = async (
  formData: FormData
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PROCESS_QA}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const { data } = response;

    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data.message,
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const processBi = async (
  formData: FormData
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PROCESS_BI}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const { data } = response;

    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data.message,
      };
    }

    return { success: false, message: data.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const deleteQaRecords = async (assetId: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DELETE_QA_RECORDS}`,

      { asset_id: assetId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;

    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: false,
        data: data?.message,
      };
    }
  } catch (error: any) {
    console.error(DELETE_QA_DATA, error);

    return {
      success: false,
      error: error?.response?.data?.message || TRY_AGAIN,
    };
  }
};
export const deleteBiRecords = async (assetId: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${BI_DELETE_RECORDS}`,

      { asset_id: assetId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;

    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: false,
        data: data?.message,
      };
    }
  } catch (error: any) {
    console.error(DELETE_QA_DATA, error);

    return {
      success: false,
      error: error?.response?.data?.message || TRY_AGAIN,
    };
  }
};

export const getQaAutomationData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${VALIDATION_ASSET_USER}`,
      // "https://awgment-onsemi-api.techsophy.com/api/awgment-llm/validation_assets_user",
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;
    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};
export const getBiAutomationData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${BI_ASSET_USER}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;
    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const getDbConnectionData = async (dbType: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DB_CONNECTIONS_DETAILS}?db_type=${dbType}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );
    const { data } = response;
    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const generatePdf = async ({
  project_name,
  dbType,
  dbHost,
  port,
  username,
  password,
  dbName,
  tablesList,
  asset_type,
}: {
  dbType: string;
  project_name: string;
  asset_type: string;
  dbHost: string;
  port: string;
  username: string;
  password: string;
  dbName: string;
  tablesList: string;
}) => {
  try {
    const formData = new FormData();
    formData?.append("db_type", dbType);
    formData?.append("asset_type", asset_type);
    formData?.append("project_name", project_name);
    formData?.append("db_host", dbHost);
    formData?.append("port", port);
    formData?.append("username", username);
    formData?.append("password", password);
    formData?.append("db_name", dbName);
    formData?.append("tables_list", tablesList);

    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GENERATE_PDF}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || error?.message || ERROR_OCCURED,
    };
  }
};

export const PseudoAsset = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PSEUDO_ASSETS_USER}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data } = response;
    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? "",
      };
    }

    return { success: false, message: data?.message };
  } catch (error: any) {
    return { success: false, message: error?.message || ERROR_OCCURED };
  }
};

export const deletePseudoCode = async (assetId: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PSEUDO_DELETE_ASSETS}`,
      { asset_id: assetId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      }
    );

    const { data, status } = response;

    if (status === 200) {
      return {
        success: true,
        data: data,
      };
    } else {
      return {
        success: false,
        data: data?.message,
      };
    }
  } catch (error: any) {
    console.error(ERROR_OCCURED, error);

    return {
      success: false,
      error: error?.response?.data?.message || ERROR_OCCURED,
    };
  }
};

export const processPc = async (
  formData: FormData
): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${PSEUDO_PROCESS}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const { data } = response;

    if (data?.status === "success") {
      return {
        success: true,
        data: data,
        message: data?.message ?? PROCESS_SUCCESS,
      };
    }

    return { success: false, message: data?.message ?? PROCESS_FAIL };
  } catch (error: any) {
    console.error(ERROR_OCCURED, error);

    return {
      success: false,
      message: error?.response?.data?.message || UNKNOWN_ERROR,
    };
  }
};
